/* eslint-disable no-console */
import { useNavigate } from 'react-router-dom';
import errorImage from '../../Assets/error.jpg';
import OverlayImage from '../../Style-guide/OverlayImage';
import ErrorPageWrapper from './style/errorPageWrapper';

const error_text =
  'We understand this can be frustrating. Your experience is important to us, and we appreciate your patience during this time. Please check back soon for updates. Thank you for your understanding!';

const ErrorPage = ({ error, resetErrorBoundary }) => {
  console.log(error?.message, '-> err message');

  const navigate = useNavigate();
  const handleReset = () => {
    resetErrorBoundary();
    navigate('/', { replace: true });
  };

  return (
    <ErrorPageWrapper>
      <h1 className='error-title'>
        It seems like the referee has paused the game due to website injury.
      </h1>
      <h1 className='error-title'>❌⚽</h1>
      <OverlayImage
        image={errorImage}
        opacity={0.6}
        alt='injured player'
        imageClassName='crash-image'
        containerClassName='error-image-container'
        overlayText={error_text}
        textContainerClassName='error-text'
      />
      <button className='err-nav-home-btn' onClick={handleReset}>
        Go to homepage
      </button>
    </ErrorPageWrapper>
  );
};

export default ErrorPage;
